/* eslint-disable global-require */
const List = () => import(/* webpackChunkName: "feriado-bundle" */'./main.vue');

export default [
  {
    name: 'fechamento-glosa-manual',
    path: '/fechamento-glosa-manual',
    components: { default: List },
    meta: {
      requiresAuth: true,
      breadcrum: 'Recurso Glosa Manual - Encerrar',
      icon: 'file-invoice',
      can: 'list',
      on: 'recursoglosamanual',
      bisneto: true,
      client: 'copass, cet, rondo',
    },
  },
];
